import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { ContactPhoneType, EmergencyContact } from "@app/project/model/emergency-contact";
import { humanNameValid, numberOnlyValid } from "@app/shared/validators";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";

import { emailValidNoRequired } from "@app/shared/validators/emailValid";
import { phoneValid } from "@app/shared/validators/phoneValid";

@Component({
    selector: "app-add-contact",
    templateUrl: "./add-contact.component.html",
    styleUrls: ["./add-contact.component.scss"],
})
export class AddContactComponent implements OnInit, AfterViewInit {
    @Output() cancel = new EventEmitter<any>();
    @Output() save = new EventEmitter<any>();
    @Input() updateItem: EmergencyContact = null;
    phoneTypeList = [
        {
            value: ContactPhoneType.home,
            label: "Home",
        },
        {
            value: ContactPhoneType.cell,
            label: "Mobile",
        },
        {
            value: ContactPhoneType.work,
            label: "Workplace",
        },
    ];

    contactForm = this.fb.group({
        id: [],
        firstName: ["", [Validators.required, humanNameValid]],
        lastName: ["", [Validators.required, humanNameValid]],
        userId: ["", [Validators.maxLength(3), numberOnlyValid]],
        ecv: [false, [Validators.required]],
        authority: [""],
        phone: ["", [Validators.required, phoneValid]],
        phoneExt: ["", Validators.maxLength(5)],
        phoneType: [ContactPhoneType.home, Validators.required],
        email: ["", [emailValidNoRequired]],
        passcode: [""],
    });

    constructor(private readonly fb: FormBuilder) {}

    ngAfterViewInit(): void {
        if (this.updateItem) {
            setTimeout(() => {
                this.contactForm.patchValue({
                    id: this.updateItem.id,
                    firstName: this.updateItem.firstName || "",
                    lastName: this.updateItem.lastName || "",
                    userId: this.updateItem.userId || "",
                    ecv: this.updateItem.ecv,
                    authority: this.updateItem.authority || "",
                    phone: this.updateItem.phone || "",
                    phoneExt: this.updateItem.phoneExt || "",
                    phoneType: this.updateItem.phoneType || "",
                    email: this.updateItem.email || "",
                    passcode: this.updateItem.passcode || "",
                });
            });
        }
    }

    ngOnInit(): void {
        this.contactForm.controls.email.valueChanges.pipe(debounceTime(500), distinctUntilChanged()).subscribe(value => {
            this.contactForm.controls.email.setValue(value.toLowerCase());
        });
    }

    saveAction() {
        Object.values(this.fields).forEach(field => {
            field.markAsTouched({ onlySelf: true });
        });

        const { value, valid } = this.contactForm;
        if (valid) {
            if (this.updateItem) {
                const data = {
                    ...this.updateItem,
                    ...value,
                };
                this.save.emit(data);
            } else {
                console.log("save", value);
                this.save.emit(value);
            }
        }
    }

    get fields() {
        return this.contactForm.controls;
    }

    filterNumbersOnly(fieldName: string) {
        const pattern = /[^0-9]/g;
        const control = this.fields[fieldName];
        control.setValue(control.value.replace(pattern, "").replace(/(\..*)\./g, "$1"));
    }
}
